import { createAsyncThunk } from "@reduxjs/toolkit";
import { Flavor } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindFlavor } from "../../flavor/api/interface";

export const findSelectFlavorExport = createAsyncThunk(
  "selectFlavorExport/findSelectFlavorExport",
  async (values: FindFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

